import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import { CREATE_GOLF_COURSE_SLOT, CREATE_GOLF_COURSE_SLOT_SUCCESS, CREATE_GOLF_COURSE_SLOT_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* createGolfCourseSlot({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-slots`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
      isFormData: true,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: CREATE_GOLF_COURSE_SLOT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_GOLF_COURSE_SLOT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_GOLF_COURSE_SLOT_ERROR, payload: error });
  }
}

export function* watchCreateGolfCourseSlot() {
  yield takeEvery(CREATE_GOLF_COURSE_SLOT, createGolfCourseSlot);
}

function* createGolfCourseSlotSaga() {
  yield all([fork(watchCreateGolfCourseSlot)]);
}

export default createGolfCourseSlotSaga;
